import{useState as e,useEffect as t,isValidElement as r,cloneElement as o,createElement as a}from"react";import{jsxs as i,jsx as n}from"react/jsx-runtime";import{createPortal as d}from"react-dom";import l from"tailwind-styled-components";import m from"clsx";import{X as s}from"lucide-react";import c from"../animate/animate.js";import{Button as b}from"../button/button.js";import{twString as u}from"../utils.js";const f=l.div`
  bottom-0
  fixed
  flex
  items-center
  justify-center
  left-0
  right-0
  top-0
  z-[9999]
`,h=l.div`
  absolute
  bg-white/50
  backdrop-blur-md
  top-0
  left-0
  right-0
  bottom-0
  z-0

  dark:bg-gray-900/50
`,p=l.div`
  bg-white
  flex
  flex-col
  p-4
  relative
  shadow-lg
  z-10

  dark:bg-gray-700
  dark:text-gray-300
`,g=l.div`
  text-base
  flex-1
`,y=l.div`
  flex
  flex-shrink-0
  items-center
`,x=l.h3`
  flex-grow
  text-lg
`,k=l.div`
  border-t
  border-gray-100
  flex
  flex-shrink-0
  items-center
  justify-end
  pt-4
  mt-4

  dark:border-gray-600
`,v=l.button`
  bg-black/5
  rounded-full
  p-1
  text-xs
  text-typography

  dark:text-gray-400
  dark:bg-black/20
`,w=u`
  border-b
  border-gray-100
  mb-4
  pb-4

  dark:border-gray-600
`,N=u`
  absolute
  right-4
`,E=u`
  min-w-[20rem]
  rounded-md
`,j=u`
  absolute
  bottom-0
  max-w-[50%]
  min-w-[25rem]
  overflow-x-hidden
  overflow-y-auto
  right-0
  top-0
`,z=({actions:l=[],children:u,className:z,header:O,headerClassName:A,layout:I="centered",mountNode:C=document.body,onDismiss:L,overlayClassName:R,visible:D=!1})=>{const[q,B]=e(D),F=m({"pointer-events-none":!D}),G=m(A,{[w]:O,[N]:!O}),H=m(z,{[E]:"centered"===I,[j]:"drawer"===I});return t((()=>{const e=e=>{"Escape"===e.key&&"function"==typeof L&&L()};return document.documentElement.addEventListener("keydown",e),()=>{document.documentElement.removeEventListener("keydown",e)}}),[L]),t((()=>{D?(B(!0),Array.from(C.children).forEach((e=>{e.setAttribute("aria-hidden","true")}))):Array.from(C.children).forEach((e=>{e.removeAttribute("aria-hidden")}))}),[D,C]),q?d(i(f,{className:m("modal-container",F),children:[n(c,{animationIn:"fadeIn",animationOut:"fadeOut",visible:D,onAnimationOutEnd:()=>{B(!1)},children:n(h,{className:R,onClick:L})}),n(c,{animationIn:"centered"===I?"zoomIn":"slideInRight",animationOut:"centered"===I?"zoomOut":"slideOutRight",visible:D,children:i(p,{"aria-describedby":"modal-content","aria-labelledby":"modal-title","aria-modal":"true",className:H,role:"dialog",children:[i(y,{className:G,children:[r(O)?o(O,{...O.props,className:m(O.props.className,"flex-grow")}):n(x,{id:"modal-title",children:O}),n(v,{onClick:L,children:n(s,{className:"flex",size:16})})]}),n(g,{id:"modal-description",children:u}),l.length>0&&n(k,{children:l.map((({label:e,...t},r)=>a(b,{...t,className:m({"ml-4":r>0}),key:r},e)))})]})})]}),C):null};export{z as default};
